import { keyIssueSelectPermissionHolderType } from "../../../../actions/key-issue-actions"

import buildPermissionHoldersConnector from "../../../common/permission-holders/build-permission-holders-connector"
import PermissionHoldersViewWidget from "../../../common/permission-holders/PermissionHoldersViewWidget"

export default buildPermissionHoldersConnector(
    "keyIssues",
    keyIssueSelectPermissionHolderType
)(PermissionHoldersViewWidget)
